/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Totp_Section_TitleInputs */

const fr_totp_section_title = /** @type {(inputs: Totp_Section_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authentification à deux facteurs (TOTP)`)
};

/**

* @param {Totp_Section_TitleInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const totp_section_title = /** @type {((inputs?: Totp_Section_TitleInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Totp_Section_TitleInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_totp_section_title(inputs)
});